export default __webpack_public_path__ + "static/media/port-fhm.ef617ae6.webp";